import { fetchQuery, graphql } from 'relay-runtime';

import { AggRelayEnvironment } from '@townsquare/relay-utils';

import { meQuery, meQuery$data } from './__generated__/meQuery.graphql';

export function fetchMe(): Promise<meQuery$data['me']['user'] | null> {
  return fetchQuery<meQuery>(
    AggRelayEnvironment,
    graphql`
      query meQuery {
        me {
          user @required(action: THROW) {
            account_id: accountId @required(action: THROW)
            picture @required(action: THROW)
            name @required(action: THROW)
            ... on AtlassianAccountUser {
              email @required(action: THROW)
              zoneinfo
              locale
            }
          }
        }
      }
    `,
    {},
  )
    .toPromise()
    .then(data => {
      if (!data) {
        return null;
      }

      return {
        account_id: data.me.user.account_id,
        email: data.me.user.email,
        locale: data.me.user.locale,
        name: data.me.user.name,
        picture: data.me.user.picture,
        zoneinfo: data.me.user.zoneinfo,
      };
    })
    .catch(() => {
      return null;
    });
}
